import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import { useTheme } from '../../../theme';
import { Caption } from '../../../typography';
export const TooltipPlain = ({ text, className, children })=>{
    const theme = useTheme('dark');
    return /*#__PURE__*/ _jsxs(Box, {
        className: className,
        sx: {
            display: 'flex',
            flexDirection: 'row',
            maxWidth: 200,
            minHeight: 24,
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ _jsx(Caption, {
                color: theme.text.generic.secondary,
                css: {
                    padding: theme.spacing(0, 1),
                    wordBreak: 'break-word'
                },
                children: text
            }),
            children
        ]
    });
};

//# sourceMappingURL=plain.js.map